import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { InvestmentRecap } from '../../models/investment-recap.model';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { Investment } from '../../models/investment.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-investment-trades-table',
  standalone: true,
  imports: [
    CommonModule, 
    TableModule, 
    Tag
  ],
  templateUrl: './investment-trades-table.html'
})
export class InvestmentTradesTableComponent extends AbstractComponent {
  public readonly walletStore = inject(WalletStoreService);

  investmentRecap = input.required<InvestmentRecap>();
  trades = computed(()=>{
    const investmentRecap = this.investmentRecap();
    return investmentRecap.tradeList;
  })

  onSelect = output<Investment>();

  
}